/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VehicleBookingResponseStatus = {
    Success: 'success',
    CardDeclined: 'card declined',
    RateNoLongerAvailable: 'rate no longer available',
    ServiceBusy: 'service busy',
    Unknown: 'unknown'
} as const;
export type VehicleBookingResponseStatus = typeof VehicleBookingResponseStatus[keyof typeof VehicleBookingResponseStatus];


export function instanceOfVehicleBookingResponseStatus(value: any): boolean {
    for (const key in VehicleBookingResponseStatus) {
        if (Object.prototype.hasOwnProperty.call(VehicleBookingResponseStatus, key)) {
            if (VehicleBookingResponseStatus[key as keyof typeof VehicleBookingResponseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VehicleBookingResponseStatusFromJSON(json: any): VehicleBookingResponseStatus {
    return VehicleBookingResponseStatusFromJSONTyped(json, false);
}

export function VehicleBookingResponseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingResponseStatus {
    return json as VehicleBookingResponseStatus;
}

export function VehicleBookingResponseStatusToJSON(value?: VehicleBookingResponseStatus | null): any {
    return value as any;
}

export function VehicleBookingResponseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): VehicleBookingResponseStatus {
    return value as VehicleBookingResponseStatus;
}

